<template>
    <div>
        <div
            v-if="tripLoaded"
            class="overflow-hidden">
            <div class="flex w-full h-full overflow-hidden gap-2 mb-2">
                <div class="w-1/2 max-h-[800px] flex flex-col">
                    <div class="space-x-2 flex-none">
                        <driver-info :drivers="drivers" />
                        <vehicle-info :vehicles="vehicles" />
                    </div>
                    <div class="h-10 py-1">
                        <hts-form-toggle
                            v-model="expanded"
                            size="v-mini"
                            color="primary"
                            class="inline-block"
                            label="Tác vụ: Expand/Collapse" />
                    </div>
                    <div class="flex-col overflow-auto flex-1">
                        <travel-route-info
                            class="flex-1"
                            :trip="trip"
                            :expanded="expanded"
                            :travel-details="trip.travelDetails"
                            :files="trip.files"
                            :date-format="dateFormat" />
                    </div>
                </div>
                <div class="w-1/2 max-h-[800px]">
                    <div
                        v-show="visibleMap"
                        class="h-[400px]">
                        <hts-map-route
                            ref="travelMap"
                            center-marker
                            :route="markers"
                            :route-separated="routes"
                            :draggable="false"
                            :show-location="showLocation"
                            :lat-lng-location-routes="CLatLngLocationRoutes"
                            direction-color="#9D9D9D" />
                    </div>
                    <div class="flex items-center">
                        <hts-ui-tabs
                            v-model="tab"
                            class="flex-1"
                            :tabs="tabs" />
                        <div class="flex-none flex items-center max-w-32 min-h-5 justify-end gap-3">
                            <hts-map-icon-map store-key="trip" />
                            <hts-map-icon-location store-key="trip" />
                        </div>
                    </div>
                    <div
                        class="overflow-auto pr-1"
                        :class="{ 'max-h-[360px]': visibleMap, 'max-h-[760px]': !visibleMap }">
                        <div v-show="tab === 'files'">
                            <trip-files :files="trip.files" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { drawJourneyTracking } from '../journey-info/utils'
import TripFiles from './trip-files.vue'
import DriverInfo from './driver-info.vue'
import VehicleInfo from './vehicle-info.vue'
import TravelRouteInfo from './travel-route-info.vue'
import routeMap from '@/pages/trucker-[id]/route/ignore/route-map'

const { markers, setMarkers, routes, setRoutes, setRoutingPositions, showLocation, CLatLngLocationRoutes } = routeMap('trip')
const { map } = $store()
const props = defineProps({
  trip: {
    type: Object,
    required: true
  },
  dateFormat: String
})

const { trip } = toRefs(props)
const tripLoaded = ref(false)
const expanded = ref(false)
const travelMap = ref<any>(null)
const visibleMap = computed(() => map.showMap.trip)
const journeys = computed(() => trip.value?.journeys || [])
const vehicles = computed(() => journeys.value.map((j: any) => j.vehicle || j.vehicleTemp))
const drivers = computed(() => vehicles.value.map((v: any) => v?.otherCompanyDriver || v?.driver))

const startLocation = ref(null)
const stopLocation = ref(null)
const tabs = ref([
  {
    label: 'Tài liệu',
    key: 'files'
  }
])
const tab = ref('files')

onMounted(() => {
  show(trip.value)
})

const show = async (trip: any) => {
  const { positionsAndWaitingTasks } = trip
  if (Array.isArray(positionsAndWaitingTasks) && positionsAndWaitingTasks.length) {
    startLocation.value = positionsAndWaitingTasks[0]
    stopLocation.value = positionsAndWaitingTasks[positionsAndWaitingTasks.length - 1]
  }
  if (trip.routingPositions) {
    setRoutingPositions(trip.routingPositions)
    setMarkers(trip.positionsAndWaitingTasks, {
      renderMarkerByIndexNumber: true
    })
    await setRoutes(trip.positionsAndWaitingTasks, {
      renderMarkerByIndexNumber: true
    })
  }
  nextTick(() => {
    tripLoaded.value = true
    drawTracking(trip.journeys)
  })
}

const drawTracking = (journeys: any[]) => {
  if (!Array.isArray(journeys)) {
    return
  }
  nextTick(() => {
    journeys.forEach((j: any) => {
      drawJourneyTracking(travelMap.value, j)
    })
  })
}

const close = () => {}

defineExpose({
  show,
  close
})
</script>
